module.exports = __webpack_public_path__ + "img/dispositivo medico.7dfa6fd2.png";